import React from 'react';
import './VideoGrid.scss';

const VideoGrid = ({ children }) => {
  return <div className="video-grid">{children}</div>;
};

export default VideoGrid;
